

<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      <div class="flex-c bobee">
        Ask Bobbee{{imageMode == true ? ' For an Image' : ''}}!
        <img src="./assets/image/bobee.png" title="Ask Bobbee!">
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div id="ask">
    <!-- <div class="bobee flex-c">
      Ask Bobbee{{imageMode == true ? ' For an Image' : ''}}!
      <img src="./assets/image/bobee.png" title="Ask Bobbee!">
    </div> -->

    <div id="mic" (click)="toggleCapture()">
      <ion-icon *ngIf="isSubmitting == false" [class.is-recording]="isRecording" name="mic-circle-outline"></ion-icon>
      <ion-spinner *ngIf="isSubmitting == true" color="secondary"></ion-spinner>
    </div>    

    <div id="submitting-message" *ngIf="isSubmitting">
      <p *ngIf="imageMode">
        Your image may take up to half a minute to generate. You can resubmit the same prompt 
        for a new image, or tweak your prompt before generating again.
      </p>
      <p *ngIf="this.base64Images != null && this.base64Images.length > 0">
        Previous images will be available below, scroll to see them.
      </p>
      <p *ngIf="!imageMode">
        You text is being generated. You can include instructions in prompt like '500 words' or 'formal tone'. 
      </p>
    </div>
    <div id="prompt-input" *ngIf="!isSubmitting">

      <app-textarea-input  [showWordCount]="false" maxWidth="none" label="Enter a prompt to get suggestions, or click above to dictate"
        [rows]="5" [autoGrow]="true" placeholder="Type and submit, or dictate by tapping mic above to start and again to submit"
        [required]="true" name="q" [(ngModel)]="prompt" [maxLength]="500" >
      </app-textarea-input>
      <div class="flex-spaced">
        <div>
          <ion-button size="small" fill="clear" (click)="prompt = null" *ngIf="prompt != null">Clear</ion-button>
        </div>
        <div>
          <ion-button size="small" (click)="submitPrompt()" [disabled]="prompt == null">Go Bobbee!</ion-button>
        </div>
      </div>
    </div>
  </div>
  
  <div id="results">
    <p *ngIf="imageMode == true && answer != null" class="incl-linebreaks">
      {{answer}}
    </p>
    <ng-container *ngIf="base64Images != null">
      <div class="imageBox" *ngFor="let i of base64Images">
        <div class="flex-spaced">
          <div>
            <!-- <ion-button size="small" *ngIf="gotVariations == false" (click)="useImage(i, true)">Get Variations</ion-button> -->
          </div>
          <ion-button size="small" (click)="useImage(i, false)">Use Image!</ion-button>
        </div>
        <img class="generatedImg" [src]="'data:image/png;base64,' + i"/>
      </div>
    </ng-container>

    <app-textarea-input [showWordCount]="true" *ngIf="imageMode == false" maxWidth="none"
      [rows]="5" [autoGrow]="true" placeholder="Bobbee's suggestion will show here!"
      [required]="false" name="q" [(ngModel)]="answer" [showWordCount]="false" [maxLength]="10000">
    </app-textarea-input>

    <div class="flex-spaced">
      <div></div>
      <div>
        <ion-button size="small" (click)="useResponse()" *ngIf="imageMode == false && answer != null">Use Response!</ion-button>
      </div>
    </div>
  </div>
</ion-content>
